import React, { useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { not } from 'ramda';
import { store, persistor } from '../store';
import { AppLoader } from '../components';
import { MainLayout } from '../layouts';
import { useGetParameters } from '../hooks';
import { PRIMA_WEBSITE_URL } from '../constants';
import * as estimatorActions from '../store/slices/estimator';

export const PersistentProvider = ({ children }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        { children }
      </PersistGate>
    </Provider>
  );
};

export const AppGlobalComponents = ({ children }) => {

  const dispatch = useDispatch();
  const { isComplete } = useSelector(state => state.estimator);
  const [ isReady, setIsReady ] = useState(false);
  const { data, fetchParameters } = useGetParameters();

  useEffect(() => {
    fetchParameters();
  }, []);

  useEffect(() => {
    if (not(data)) return;
    setIsReady(true);
  }, [data]);

  useEffect(() => {
    if (isComplete) {
      dispatch(estimatorActions.setIsComplete(false));
      window.location.href = PRIMA_WEBSITE_URL;
    }
  }, [isComplete]);

  return (
    <AppLoader>
      {
        isReady && (
          <MainLayout>
            { children }
          </MainLayout>
        )
      }
    </AppLoader>
  );
};
